module.exports = "<div ng-if=\"worker.hasFailed()\" class=\"alert alert-danger\">\n  <strong>Chyba!</strong>\n  <span ng-if=\"worker.getError().is('NotAuthorizedException')\">\n    Nepovolený prístup - \n  </span>\n    {{worker.getError().message}}\n  <br>\n  <small>{{worker.getError().type}}</small>\n  <div ng-if=\"worker.getError().cause\">\n    {{worker.getError().cause.message}}\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/util/ErrorMessage.html
// module id = 196
// module chunks = 0